import Vue from "vue";
import Toast from "vue-toastification";

Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
});

export const toastUtil = {
  show: function (msg) {
    // Vue.$bvModal.show("modal-primary");
    if (msg == null) return;
    Vue.$toast.success(msg, {
      position: "bottom-center",
      timeout: 1500,
      title: "title",
      icon: true,
      solid: true,
      closeButton: "button",
    });
  },
};
